import moment from 'moment';
import * as api from '@/api/logger';
import { LOGGER } from '@/store/types';
import { AdminPointLog, AdminCoinLog, AdminPayment } from '@/api/types/logger';
import { finalizeAction, ActionType } from '@/store/actions';

type listType = AdminPointLog | AdminCoinLog | AdminPayment;
export interface StoreLoggerState {
  list: listType[];
  kw: string;
  limit: number;
  nextPoint: number;
  noMore: boolean;
  type: string;
  loading: boolean;
  loaded: boolean;
  updateTime: number;
}

export default {
  namespaced: true,
  modules: {
  },
  state: {
    list: [],
    kw: '',
    limit: 25,
    nextPoint: null,
    noMore: false,
    type: '', // point coin pay
    loading: false,
    loaded: false,
    updateTime: 0,
  },
  getters: {
    logsList(state) {
      if (!state.list) {
        return null;
      }
      return state.list.map(item => Object.assign({}, item, { timeCreate: moment(item.timeCreate * 1000).format('YYYY-MM-DD HH:mm:ss') }));
    },
  },
  actions: {
    [LOGGER.GET_LOGGER_LIST](
      { commit, state },
      { action: rawAction = '', kw, type }: { action?: ActionType; kw?: string; type?: string } = {},
    ) {
      const action = finalizeAction(rawAction, state.loaded && state.kw === kw, state.noMore);
      if (action && !state.loading) {
        commit(LOGGER.GET_LOGGER_LIST, { status: 'start' });
        const point = action === 'reload' ? null : state.nextPoint;
        return new Promise((resolve, reject) => {
          if (type === 'point') {
            api.getAdminPointLogs(point, state.limit, kw).then((res) => {
              commit(LOGGER.GET_LOGGER_LIST, {
                status: 'success',
                kw,
                action,
                data: res.data,
              });
              resolve();
            }).catch(reject);
          }
          if (type === 'coin') {
            api.getAdminCoinLogs(point, state.limit, kw).then((res) => {
              commit(LOGGER.GET_LOGGER_LIST, {
                status: 'success',
                kw,
                action,
                data: res.data,
              });
              resolve();
            }).catch(reject);
          }
          if (type === 'pay') {
            api.getAdminPayLogs(point, state.limit, kw).then((res) => {
              commit(LOGGER.GET_LOGGER_LIST, {
                status: 'success',
                kw,
                action,
                data: res.data,
              });
              resolve();
            }).catch(reject);
          }
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [LOGGER.GET_LOGGER_LIST](state, { status, kw, action, data }) {
      if (status === 'start') {
        state.loading = true;
        if (action === 'reload') {
          state.list = [];
        }
      } else if (status === 'failure') {
        state.list = [];
        state.loading = false;
        state.noMore = true;
      } else {
        if (status === 'success') {
          if (data.length) {
            state.loaded = true;
            state.kw = kw;
            state.list = action === 'reload' ? data : state.list.concat(data);
            state.noMore = data.length < state.limit;
            state.nextPoint = data[data.length - 1].id;
            state.updateTime = new Date().valueOf();
          } else {
            state.list = [];
            state.loading = false;
            state.noMore = true;
          }
        }
        state.loading = false;
      }
    },
  },
};
